import create from 'zustand';

import { Auth0Client, Auth0ClientOptions } from '@auth0/auth0-spa-js';
import { AUTH0_LOGOUT_URL } from '../../config';
import { segment } from '@sky-tv-group/shared';
import { myAccountService } from '../../services';

interface Store {
  isAuthenticated: boolean;
  loading: boolean;
  user?: any;
  client?: Auth0Client;
  load: (config: Auth0ClientOptions, onRedirectCallback: (appState: any) => void) => void;
  logout: () => void;
  login: () => void;
}
//github.com/auth0/auth0-spa-js/blob/06026747255ef7798cc96820904f855fc993914c/src/index.ts
async function createAuth0Client(options: Auth0ClientOptions) {
  const auth0 = new Auth0Client(options);
  try {
    await auth0.getTokenSilently(options);
  } catch (error) {}
  return auth0;
}

export const [useAuth0, API] = create<Store>((set, get) => ({
  isAuthenticated: false,
  loading: true,
  load: async (config, onRedirectCallback) => {
    try {
      const client = await createAuth0Client(config);
      set({ client });
      let { search } = window.location;
      let fromAuth0LoginPage = false;
      if (search.includes('error=unauthorized')) {
        get().logout();
        return;
      }
      if (search.includes('code=') && search.includes('state=')) {
        const { appState } = await client.handleRedirectCallback();
        onRedirectCallback(appState);
        fromAuth0LoginPage = true;
      }
      const isAuthenticated = await client.isAuthenticated();
      set({ isAuthenticated });
      if (isAuthenticated) {
        const user = await client.getUser({
          scope: config.scope!,
          audience: config.audience!,
        });
        set({ user });

        if (fromAuth0LoginPage) {
          const profile = await myAccountService.getProfile();
          const customer = await myAccountService.getCustomer();

        const personalDetails = customer?.Parties?.[0].types['MP:Primary']?.personalDetails
        const contactDetails = customer?.Parties?.[0].types['MP:Primary']?.contactDetails?.[0]
        const userPhone = (contactDetails?.areaCode ?? "" + contactDetails?.number ?? "" + "").toString();

        const identifyPayload = {
          sub: user.sub,
          email: profile.email,
          userPhone:userPhone,
          accountNumber: profile.accountNumber,
          profileId: profile.profileId,
          firstName: personalDetails?.firstName ?? "",
          lastName: personalDetails?.lastName ?? "",
          dob: personalDetails?.dob ?? "",
          customerGroupTypesString :profile?.groups.join(','),
        };

          segment.identify(user.sub, profile.email, profile.accountNumber, profile.profileId, identifyPayload);
          segment.signedIn(customer.accountNumber);
        }
      }
      set({ loading: false });
    } catch (err) {
      console.error(err);
      window.location.assign('/');
    }
  },
  logout: () => {
    get().client?.logout({ returnTo: AUTH0_LOGOUT_URL });
  },
  login: () => {
    get().client?.loginWithRedirect({ redirect_uri: window.location.origin });
  },
}));

let getUser = () => API.getState().user;
let getClient = () => API.getState().client;
export { getUser, getClient };
